
import React from "react";
import GenericSelector from "./GenericSelector";
import LangContext from "../contextProvider/LangContext";

class GenericSelectorBranches extends React.Component/*<Props, State>*/ {
    constructor(props) {
        super(props);
        this.id = 'GENERIC_SELECTOR_BRANCHES';
        this.api = 'get_branch_list'
        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericSelector }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    render() {
        let gt = this.getText;

        return (<GenericSelector
            {...this.props}
            id={this.id}
            api={this.props.notApi ? undefined : this.api}
            modalStyle={{
                title: gt(this.props.multi ? 21067 : 21068),
                col1Title: gt(21069),
                col2Title: gt(21070),
                cancelText: gt(21071),
                clearText: gt(21072),
            }}
        />)
    }
}

export default GenericSelectorBranches;
